<div class="wrapper" (click)="fileInput.click()">
    {{ filename }}
</div>

<input type="file" hidden #fileInput (change)="selectFile($event)">